(function(){
  if(window.__p4pCC)return;window.__p4pCC=true;
  var ICON='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 7h12l1 13H5L6 7z"/><path d="M9 10V6a3 3 0 0 1 6 0v4"/></svg>';
  var CHECK='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
  var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  var sold=(window.P4P_SOLD||'').toLowerCase();
  var LBL=window.P4P_LBL||{add:'In den Warenkorb',sold:'Ausverkauft'};

  function handleOf(card){
    var a=card.querySelector('a[href*="/products/"]');if(!a)return null;
    var m=a.getAttribute('href').split('?')[0].match(/\/products\/([^\/#]+)/);return m?m[1]:null;
  }
  function isSold(card){
    if(!sold)return false;
    var b=card.querySelectorAll('.card__badge .badge');
    for(var i=0;i<b.length;i++){if(b[i].textContent.trim().toLowerCase()===sold)return true;}
    return false;
  }
  function place(card){
    var inner=card.querySelector('.card__inner'),w=card.querySelector('.p4p-cc');
    if(!inner||!w)return;
    w.style.top=(inner.offsetTop+inner.offsetHeight-w.offsetHeight-8)+'px';
  }
  var RO=window.ResizeObserver?new ResizeObserver(function(es){es.forEach(function(e){var c=e.target.closest('.card-wrapper');if(c)place(c);});}):null;
  function inject(scope){
    (scope||document).querySelectorAll('.card-wrapper.product-card-wrapper:not([data-p4p-cc])').forEach(function(card){
      card.setAttribute('data-p4p-cc','1');
      var inner=card.querySelector('.card__inner');var handle=handleOf(card);
      if(!inner||!handle||isSold(card))return;
      var w=document.createElement('div');w.className='p4p-cc';w.setAttribute('data-handle',handle);
      w.innerHTML='<button type="button" class="p4p-cc__btn" aria-label="'+LBL.add+'">'+ICON+'</button>';
      card.appendChild(w);place(card);
      if(RO)RO.observe(inner);
      var im=inner.querySelector('img');if(im&&!im.complete)im.addEventListener('load',function(){place(card);});
    });
  }
  function closePops(except){
    document.querySelectorAll('.p4p-cc__pop').forEach(function(p){if(p!==except)p.hidden=true;});
  }
  function flash(w,cls){
    var b=w.querySelector('.p4p-cc__btn');w.classList.add(cls);
    if(cls==='is-done')b.innerHTML=CHECK;
    setTimeout(function(){w.classList.remove(cls);b.innerHTML=ICON;b.disabled=false;},1600);
  }
  function addToCart(id,w){
    var b=w.querySelector('.p4p-cc__btn');b.disabled=true;
    var cart=document.querySelector('cart-notification')||document.querySelector('cart-drawer');
    var body={items:[{id:id,quantity:1}]};
    if(cart&&cart.getSectionsToRender){
      body.sections=cart.getSectionsToRender().map(function(s){return s.id;}).join(',');
      body.sections_url=window.location.pathname;
    }
    fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)})
      .then(function(r){return r.json().then(function(j){return {ok:r.ok,j:j};});})
      .then(function(res){
        if(!res.ok||res.j.status){flash(w,'is-error');return;}
        flash(w,'is-done');
        var j=res.j;
        try{
          if(cart&&cart.renderContents){
            var item=(j.items&&j.items[0])||j;
            item.sections=j.sections;
            if(cart.setActiveElement)cart.setActiveElement(document.activeElement);
            cart.renderContents(item);
          }else{
            fetch(root+'cart.js').then(function(r){return r.json();}).then(function(c){
              document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]').forEach(function(e){e.textContent=c.item_count;});
            });
            if(!document.querySelector('cart-drawer, cart-notification'))window.location.href=root+'cart';
          }
        }catch(e){}
      }).catch(function(err){console.error('p4p cart',err);flash(w,'is-error');});
  }
  document.addEventListener('click',function(e){
    var btn=e.target.closest&&e.target.closest('.p4p-cc__btn');
    var size=e.target.closest&&e.target.closest('.p4p-cc__size');
    if(size){
      e.preventDefault();e.stopPropagation();
      var w=size.closest('.p4p-cc');closePops();addToCart(parseInt(size.getAttribute('data-id'),10),w);return;
    }
    if(btn){
      e.preventDefault();e.stopPropagation();
      var w=btn.closest('.p4p-cc');var pop=w.querySelector('.p4p-cc__pop');
      if(pop){pop.hidden=!pop.hidden;closePops(pop.hidden?null:pop);return;}
      btn.disabled=true;
      fetch(root+'products/'+w.getAttribute('data-handle')+'.js').then(function(r){return r.json();}).then(function(p){
        var av=p.variants.filter(function(v){return v.available;});
        if(!av.length){btn.disabled=false;flash(w,'is-error');w.setAttribute('title',LBL.sold);return;}
        if(av.length===1){addToCart(av[0].id,w);return;}
        var d=document.createElement('div');d.className='p4p-cc__pop';
        av.forEach(function(v){
          var s=document.createElement('button');s.type='button';s.className='p4p-cc__size';
          s.setAttribute('data-id',v.id);s.textContent=v.public_title||v.title;d.appendChild(s);
        });
        w.appendChild(d);btn.disabled=false;closePops(d);
      }).catch(function(){btn.disabled=false;flash(w,'is-error');});
      return;
    }
    if(!(e.target.closest&&e.target.closest('.p4p-cc')))closePops();
  },true);
  function start(){
    inject(document);
    new MutationObserver(function(m){
      for(var i=0;i<m.length;i++){if(m[i].addedNodes.length){inject(document);break;}}
    }).observe(document.body,{childList:true,subtree:true});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
})();
